import { render, staticRenderFns } from "./TaskItemModal.vue?vue&type=template&id=df34c084&scoped=true"
import script from "./TaskItemModal.vue?vue&type=script&lang=ts"
export * from "./TaskItemModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df34c084",
  null
  
)

export default component.exports